/** Joins class names, dropping the falsy ones: cx('btn', wide && 'wide'). */
export const cx = (...parts: (string | false | null | undefined)[]): string => parts.filter(Boolean).join(' ');
